export default function Footer() {
  return `
    <div class="tm-c-footer">
      <div class="tm-c-container">
        <a href="https://liam.codes" target="_blank">liam.codes</a>
      </div>
    </div>
  `;
}
